import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const HeroPortrait = () => {
  return (
    <section className="relative min-h-screen flex items-center bg-black overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/04f746b3ed1b706c366f82a4827e10cb.jpg"
          alt="Mountain landscape background"
          width={1920}
          height={1080}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 py-32 w-full">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="text-gold text-sm font-semibold tracking-widest uppercase mb-4 block">
              Our Founder
            </span>
            <h1 className="text-6xl md:text-7xl font-black text-white mb-6 leading-tight">
              Dr. Marcus Thornwell
            </h1>
            <p className="text-2xl text-cream/80 mb-8 font-light italic">
              "Every problem deserves to be properly identified and escalated."
            </p>
            <p className="text-lg text-light-gray mb-10 leading-relaxed">
              With over 27 years dedicated to the rigorous study and identification of problems across all sectors, Dr. Thornwell founded The Real Problem Company to bring unprecedented awareness to issues that organizations didn't even know existed.
            </p>

            <div className="flex flex-wrap gap-5">
              <Link
                to="/contact"
                className="group inline-flex items-center gap-3 bg-gold text-black px-8 py-4 rounded-full text-base font-bold hover:bg-white transition-all duration-300 whitespace-nowrap"
              >
                Discover Your Problems
                <motion.i className="ri-arrow-right-line text-xl" whileHover={{ x: 5 }} />
              </Link>
              <Link
                to="/financial-success"
                className="inline-flex items-center gap-3 border-2 border-cream/50 text-cream px-8 py-4 rounded-full text-base font-bold hover:bg-cream hover:text-black transition-all duration-300 whitespace-nowrap"
              >
                View Our Solutions
              </Link>
            </div>
          </motion.div>

          {/* Right Image */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative"
          >
            <div className="relative rounded-3xl overflow-hidden">
              <motion.div
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.6 }}
                className="aspect-[4/5] overflow-hidden"
              >
                <img
                  src="https://readdy.ai/api/search-image?query=Distinguished%20professional%20executive%20man%20in%20his%2050s%20wearing%20impeccable%20charcoal%20gray%20three%20piece%20suit%20with%20gold%20tie%20standing%20confidently%20in%20luxurious%20modern%20office%20with%20dramatic%20sunset%20mountain%20view%20through%20floor%20to%20ceiling%20windows%2C%20sophisticated%20corporate%20portrait%20photography%20with%20warm%20golden%20hour%20lighting%20and%20shallow%20depth%20of%20field%2C%20serious%20authoritative%20expression&width=800&height=1000&seq=founder-portrait-001&orientation=portrait"
                  alt="Dr. Marcus Thornwell"
                  width={800}
                  height={1000}
                  className="w-full h-full object-cover object-top"
                />
              </motion.div>

              {/* Experience Badge */}
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className="absolute bottom-8 left-8 bg-gold text-black px-6 py-4 rounded-2xl shadow-2xl"
              >
                <div className="text-3xl font-black">27+</div>
                <div className="text-sm font-semibold">Years Identifying Problems</div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroPortrait;